export const slotBarSymbolNames = {
  icon1: 'icon1',
  icon2: 'icon2',
  icon3: 'icon3',
  icon4: 'icon4',
  icon5: 'icon5',
  icon6: 'icon6',
  icon7: 'icon7',
  icon8: 'icon8',
  icon12: 'jackPotIcon',
};
export const slotSpineKey = {
  1: slotBarSymbolNames.icon1,
  2: slotBarSymbolNames.icon2,
  3: slotBarSymbolNames.icon3,
  4: slotBarSymbolNames.icon4,
  5: slotBarSymbolNames.icon5,
  6: slotBarSymbolNames.icon6,
  7: slotBarSymbolNames.icon7,
  8: slotBarSymbolNames.icon8,
  400: slotBarSymbolNames.icon12,
  board: 'board',
  mainBg: 'mainBg',
  winCoin: 'winCoin',
  loading: 'loading',
  winLine: 'winLine',
  winPopup: 'winPopup',
  gameLogo: 'gameLogo',
  gambleCard: 'gambleCard',
  jackPotItem: 'jackPotItem',
  gambleSymbol: 'gambleSymbol',
  jackPotSymbol: 'jackPotSymbol',
  winSymbolBorder: 'winSymbolBorder',
  jackpotWinPopup: 'jackpotWinPopup',
  jackpotBackGroundLogo: 'jackpotBackGroundLogo',
  jackpotBackGroundStage: 'jackpotBackGroundStage',
  jackpotBackGroundStars: 'jackpotBackGroundStars',
  jackpotBackGroundProjector: 'jackpotBackGroundProjector',
  jackpotBackGroundLights: 'jackpotBackGroundLights',
  gambleAmountFrame: 'gambleAmountFrame',
  jackpotAmountBoard: 'jackpotAmountBoard',
  jackpotCongratsPopup: 'jackpotCongratsPopup',
  jackpotGameSceneBoard: 'jackpotGameSceneBoard',
  boardFrame: 'boardFrame'
};

export const randomGeneratedIcons = [
  '4',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '4',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
];

export const randomGeneratedIconsWithSeven = [
  '4',
  '1',
  '1',
  '1',
  '4',
  '5',
  '4',
  '8',
  '1',
  '1',
  '1',
  '4',
  '1',
];

export const randomGeneratedIconsWithSevenOneLine = [
  '1',
  '4',
  '7',
  '4',
  '5',
  '4',
  '7',
  '7',
  '3',
  '7',
  '3',
  '5',
  '4',
  '6',
];

export const randomGeneratedIconsWithSevenTwoLine = [
  '2',
  '1',
  '1',
  '3',
  '4',
  '5',
  '4',
  '8',
  '8',
  '4',
  '7',
  '3',
  '5',
  '4',
  '1',
];

export const randomIconsGroup = [
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIconsWithSevenTwoLine,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIconsWithSevenOneLine,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIconsWithSevenOneLine,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIconsWithSevenOneLine,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIconsWithSeven,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIcons,
  randomGeneratedIconsWithSevenTwoLine,
];


export const specialIconKeys = {
  symbol1: 1,
  symbol2: 2,
  symbol3: 3,
  symbol4: 4,
  wild: 7,
  scatter1: 8,
};

export const iconStates = {
  win: 'win',
  idle: 'idle',
  blur: 'blur',
  noWin: 'noWin',
  winPt1: 'winLoop',
  winExpand: "winExpand"
};

export const spineNames = {
  bg: 'backGround',
};